import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import Section from './section';
import StackAppsCard from '../../../../shared/library/cards/stack-apps/stack-apps-card';
import {MobileContext} from '../../../../shared/enhancers/mobile-enhancer';
import gql from 'graphql-tag';
import AddItem from '../../../../shared/library/buttons/add-item/index.jsx';
import {IsAdminContext} from '../../enhancers/is-admin';

export const query = gql`
  query stackAppsList($id: ID!, $orgId: ID, $first: Int, $after: String) {
    company(id: $id) {
      id
      stackApps(orgId: $orgId, first: $first, after: $after) {
        count
        edges {
          node {
            id
            description
            name
            canonicalUrl
            stacks {
              count
              edges {
                node {
                  id
                }
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

const StackApplications = ({companyId, companySlug, currentOrg, count}) => {
  const isAdmin = useContext(IsAdminContext);
  const isMobile = useContext(MobileContext);
  return (
    <Section
      title="Applications"
      count={count}
      query={query}
      dataKey="stackApps"
      variables={{id: companyId, orgId: currentOrg && currentOrg.id}}
      gridCols={isMobile ? 1 : 3}
      initialPageSize={isMobile ? 3 : 9}
      pageSize={9}
      privateMode={true}
      customTitleComponent={
        isAdmin && (
          <AddItem
            addItemTitle="Add application"
            addItemLink={`/companies/${companySlug}/applications/new`}
          />
        )
      }
    >
      {({edges}) => {
        return edges.length > 0
          ? edges.map(e => (
              <StackAppsCard
                key={e.node.id}
                name={e.node.name}
                item={e.node}
                count={e.node.stacks.count}
              />
            ))
          : 'No Stack Applications Found!';
      }}
    </Section>
  );
};

StackApplications.propTypes = {
  companyId: PropTypes.any.isRequired,
  companySlug: PropTypes.string,
  currentOrg: PropTypes.object,
  count: PropTypes.number.isRequired
};

export default StackApplications;
